/* assets/cart-shipping-format.js */
(function () {
  "use strict";

  function extractDeliveryText(line) {
    // tenta achar algo tipo "2 dias", "2-4 dias", "2–4 dias", "2 days", etc.
    const re = /(\d+)\s*(?:[-–]\s*(\d+))?\s*(dia|dias|day|days)\b/i;
    const m = line.match(re);
    if (!m) return null;

    const a = m[1];
    const b = m[2];
    const unit = /day/i.test(m[3]) ? "dias" : (m[3].toLowerCase().startsWith("dia") ? "dias" : "dias");

    if (b) return `Prazo: ${a}–${b} ${unit}`;
    return `Prazo: ${a} ${unit}`;
  }

  function parsePrice(line) {
  // remove "BRL" e pega um número com 2 casas
  const cleaned = line.replace(/\bBRL\b/gi, "").trim();
  const m = cleaned.match(/(\d{1,3}(?:[.,]\d{3})*[.,]\d{2})/);
  if (!m) return null;

  let s = m[1];

  // "1.234,56" -> "1234.56"
  const hasComma = s.includes(",");
  const hasDot = s.includes(".");
  if (hasComma && hasDot) {
    s = s.replace(/\./g, "").replace(",", ".");
  } else {
    s = s.replace(",", ".");
  }

  const num = Number(s);
  if (!Number.isFinite(num)) return null;

  // formata pt-BR e mantém "R$"
  const formatted = num.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return `R$ ${formatted}`;
}


  function buildRatesHTML(lines) {
    const items = [];

    for (const line of lines) {
      if (!line || !line.includes(":")) continue;

      const parts = line.split(":");
      const nameRaw = (parts[0] || "").trim();
      const rest = parts.slice(1).join(":").trim();

      const delivery = extractDeliveryText(line); // tenta achar no line inteiro
      const price = parsePrice(rest) || parsePrice(line);

      if (!nameRaw || !price) continue;

      items.push({
        name: nameRaw,
        delivery,
        price
      });
    }

    if (!items.length) return null;

    const html = items.map((it) => {
      return `
        <div class="m-shipping-rates__item">
          <div class="m-shipping-rates__left">
            <div class="m-shipping-rates__name">${escapeHtml(it.name)}</div>
            ${it.delivery ? `<div class="m-shipping-rates__time">${escapeHtml(it.delivery)}</div>` : ``}
          </div>
          <div class="m-shipping-rates__price">${escapeHtml(it.price)}</div>
        </div>
      `;
    }).join("");

    return `<div class="m-shipping-rates">${html}</div>`;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function formatShippingRates(container) {
    if (!container) return;

    // evita reformatar markup já tratado
    if (container.querySelector(".m-shipping-rates")) return;

    const text = (container.innerText || "").trim();
    if (!text) return;

    // pega só as linhas que parecem rates (as que têm ":")
    const lines = text.split("\n").map(l => l.trim()).filter(Boolean);

    const built = buildRatesHTML(lines);
    if (!built) return;

    // preserva qualquer heading/mensagem acima, se existir
    // (ex: "Encontramos 4 taxa(s)...")
    const headingLines = lines.filter(l => !l.includes(":"));
    const heading = headingLines.length ? `<div class="m-shipping-rates__heading" style="margin-bottom:10px;">${escapeHtml(headingLines.join(" "))}</div>` : "";

    container.innerHTML = heading + built;
  }

  function init() {
    const root = document.getElementById("m-addons-shipping");
    if (!root) return;

    const ratesBox = root.querySelector(".m-cart-addon__shipping-rate");
    if (!ratesBox) return;

    // observa quando o tema atualiza o resultado
    const obs = new MutationObserver(() => formatShippingRates(ratesBox));
    obs.observe(ratesBox, { childList: true, subtree: true, characterData: true });

    // tentativa inicial
    formatShippingRates(ratesBox);
  }

  document.addEventListener("DOMContentLoaded", init);
})();
